export default [
  {
    path: '/active-gradereport-original/index',
    name: 'index',
    component: () => import('@/views/active-gradereport-original/index'),
    meta: {
      title: '分析报告'
    }
  },
  {
    path: '/active-gradereport-original/my-list',
    name: 'my-list',
    component: () => import('@/views/active-gradereport-original/my-list'),
    meta: {
      title: '分析报告'
    }
  },{
    path: '/active-gradereport-original/buy-record',
    name: 'buy-record',
    component: () => import('@/views/active-gradereport-original/buy-record'),
    meta: {
      title: '购买记录'
    }
  },{
    path: '/active-gradereport-original/about-our',
    name: 'about-our',
    component: () => import('@/views/active-gradereport-original/about-our'),
    meta: {
      title: '关于我们'
    }
  },{
    path: '/active-gradereport-original/msg-input',
    name: 'msg-input',
    component: () => import('@/views/active-gradereport-original/msg-input'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport-original/first-msg',
    name: 'first-msg',
    component: () => import('@/views/active-gradereport-original/first-msg'),
    meta: {
      title: '信息填写'
    }
  },{
    path: '/active-gradereport-original/grade-report',
    name: 'grade-report',
    component: () => import('@/views/active-gradereport-original/grade-report'),
    meta: {
      title: '成绩报告'
    }
  },{
    path: '/active-gradereport-original/pay',
    name: 'pay',
    component: () => import('@/views/active-gradereport-original/pay'),
    meta: {
      title: '支付'
    }
  },{
    path: '/active-gradereport-original/batch',
    name: 'batch',
    component: () => import('@/views/active-gradereport-original/batch'),
    meta: {
      title: '查批次'
    }
  },{
    path: '/active-gradereport-original/oneline',
    name: 'oneline',
    component: () => import('@/views/active-gradereport-original/oneline'),
    meta: {
      title: '一分一段'
    }
  },{
    path: '/active-gradereport-original/agreement',
    name: 'agreement',
    component: () => import('@/views/active-gradereport-original/agreement'),
    meta: {
      title: '协议内容'
    }
  },{
    path: '/active-gradereport-original/paySuccess',
    name: 'paySuccess',
    component: () => import('@/views/active-gradereport-original/paySuccess'),
    meta: {
      title: '支付成功'
    }
  },
  {
    path: '/active-gradereport-original/transit',
    name: 'transit',
    component: () => import('@/views/active-gradereport-original/transit'),
    meta: {
      title: ''
    }
  }
]
